import us from './defines';
import { translate } from 'shared/services/I18nService';

/*
 This file creates the toolbar for uscope, creates the settings panel, and other panels and handles their events.

 The "main" toolbar contains the feature access buttons and settings.  It is positioned below
 the selected image's toolbar.
 */

const i18Namespace = 'uScope.others.toolbar';

export function Toolbar () {
  const $t = translate.scope(i18Namespace);

  var self = this;
  var jtoolbar;

  // ............................................ position() public
  //    position - This function positions the main toolbar on the selected image.
  this.position = function (crOffset) {
    if (crOffset == undefined) { jtoolbar.css({'left': '2px', 'top': '2px'}); } else { jtoolbar.css({'left': crOffset.x + 'px', 'top': (crOffset.y + crOffset.h) + 'px'}); }
  };

  // ............................................ init_() local
  //    init_ = This function creates the toolbar, sizes it and adds its event handlers.
  var init_ = function () {
    jtoolbar = $(us.idHashROOT).find('#' + us.idTOPTOOLBARV); // if the toolbar already exists, remove it
    if (jtoolbar.length) { jtoolbar.remove(); }
    jtoolbar = $('<div/>', { // build the toolbar div tag
      'id': us.idTOPTOOLBARV,
      'class': us.clsSUPEROVERLAY + ' ' + us.clsTRANSPARENT,
      'title': $t('toggle-autopan')
    });

    $(us.idHashROOT).append(jtoolbar); // append the toolbar to the root node
    self.position();

    // Expose the ability to add a button externally
    let lastButton = { button: null, position: -1 };
    self.addButton = function (button, position) { // simple impl for now; only one button has position
      if (lastButton.position > 0) {
        return $(button).insertBefore(lastButton.button);
      } else {
        jtoolbar.append(button);
      }

      if (position > lastButton.position) {
        lastButton = { button, position };
      }
    };
  };

  init_();
}

// -------------------------------------------------------------------------------------------------
//    ICON MANAGEMENT
// -------------------------------------------------------------------------------------------------
// ............................................ setIconState
//    setIconState - This function sets an icon to its active, enabled or disabled state
//            OR sets the muti-image icon to one of its 3 possible states.
//
//        Note that it depends upon the css class naming convention:
//            classRoot-e - defines icon for enabled state
//            classRoot-d - defines icon for disabled state
//            classRoot-a - defines icon for active state
//
export function setIconState (jContainer, classRoot, state) {
  if (state == 'active') { // most toolbar icon states
    jContainer.addClass(classRoot + '-a').removeClass(classRoot + '-e').removeClass(classRoot + '-d');
  } else if (state == 'enabled') {
    jContainer.addClass(classRoot + '-e').removeClass(classRoot + '-a').removeClass(classRoot + '-d');
  } else if (state == 'disabled') {
    jContainer.addClass(classRoot + '-d').removeClass(classRoot + '-e').removeClass(classRoot + '-a');
  } else {
    // Do nothing
  }
}

// -------------------------------------------------------------------------------------------------
//    DIALOG HELPER METHODS
// -------------------------------------------------------------------------------------------------

// ............................................ genericMessage
//    genericMessage - A general purpose message panel that removes itself from the DOM when closed.
//
//    parameters:
//        message:        required, string, your message to the user
//        title:            optional, string, default "Notice"
//
export function genericMessage (message = '', title = 'Notice') {
  const $t = translate.scope(i18Namespace);

  var jPanel = $('<div id=' + us.idMSGPANEL + ' title="' + title + '">' + message + '</div>');

  $(jPanel).dialog({
    autoOpen: true,
    modal: true,
    closeOnEscape: false,
    resizable: false,
    dialogClass: 'uscope-dialog dialogMover',
    close: function (event, ui) {
      $(this).remove();
    },
    buttons: [{
      text: $t('ok'),
      click: function () {
        $(this).remove();
      }
    }]
  });

  // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
  //    (would normally want it appended to the uscope div)
  // note that the dialog is the parent to the panel created
  jPanel.parent().css('zIndex', 9999).appendTo('body');
}
